/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Predicate from 'predicates/models/predicate';
// is this allowed under embroider? an in-repo addon importing from the app?
import { objectTypes, humanReadableObjectNames } from 'embercom/models/data/matching-system/matching-constants';
import { eventVerbsMap, contentEvents } from 'embercom/models/data/stats-system/stats-constants';
import { defaultEventVerbsMap } from 'embercom/models/data/stats-system/stats-constants';
import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { camelize } from '@ember/string';
const GOAL_HIT_STAT = 'goal_hit';
export default Predicate.extend({
  store: service(),
  isEditable: true,
  defaultComparison: 'in',
  genericType: 'contentEvent',
  _shouldLoadContentObject: false,
  contentEvent: computed('attribute', function () {
    if (contentEvents.hasOwnProperty(this.attribute)) {
      return contentEvents[this.attribute];
    }
    console.warn(`No content event found for ${this.attribute}. Please add one to 'contentEvents' in app/models/data/stats-system/stats-constants.js`);
  }),
  contentType: reads('contentEvent.objectType'),
  statisticName: reads('contentEvent.statistic'),
  basedOnGoal: computed('statisticName', function () {
    return this.statisticName === GOAL_HIT_STAT;
  }),
  isValid: computed('comparison', 'value', function () {
    return ['in', 'nin'].includes(this.comparison) && !!this.value;
  }),
  name: computed('comparison', 'verb', 'contentType', function () {
    let objectType = objectTypes[camelize(this.contentType)];
    let humanReadableObjectName = objectType ? humanReadableObjectNames[objectType] : this.contentType;
    if (this.comparison === 'nin') {
      return `Hasn't ${this.verb} the ${humanReadableObjectName}`;
    }
    return `Has ${this.verb} the ${humanReadableObjectName}`;
  }),
  verb: computed('contentType', 'statisticName', 'attribute', function () {
    let eventVerb;
    if (eventVerbsMap.hasOwnProperty(this.contentType)) {
      eventVerb = eventVerbsMap[this.contentType][this.statisticName];
    } else {
      eventVerb = defaultEventVerbsMap[this.statisticName];
    }
    if (eventVerb) {
      return eventVerb;
    }
    console.warn(`No event verb found for ${this.attribute}. Please add one to 'eventVerbsMap' in app/models/data/stats-system/stats-constants.js`);
    return this.statisticName;
  }),
  description: reads('_contentObjectTitle'),
  descriptionWithName: computed('name', '_contentObjectTitle', function () {
    return `${this.name} '${this._contentObjectTitle}'`;
  }),
  _contentObjectId: computed('contentType', 'value', function () {
    let matchingSystemObjectType = camelize(this.contentType);
    return `${objectTypes[matchingSystemObjectType]}_${this.value}`;
  }),
  _contentObjectTitle: computed('value', '_contentObjectId', 'contentType', '_shouldLoadContentObject', function () {
    if (this.value) {
      let title = this.store.peekRecord('matching-system/client-data', this.value)?.title || this.store.peekRecord('content-object', this._contentObjectId)?.title;
      if (isEmpty(title) && this._isRepliedToContentType()) {
        this._loadContentObject();
      }
      if (objectTypes[this.contentType] === objectTypes.series && isEmpty(title)) {
        title = this.store.peekRecord('series/series', this.value)?.title;
      }
      return title || 'Untitled';
    }
  }),
  _isRepliedToContentType() {
    let repliedToContentTypes = [objectTypes.email, objectTypes.customBot, objectTypes.post, objectTypes.chat];
    return repliedToContentTypes.includes(objectTypes[this.contentType]);
  },
  async _loadContentObject() {
    let objectTypeId = this._contentObjectId.split('_')[0];
    this.set('_shouldLoadContentObject', true);
    await this.store.query('content-object', {
      object_type: objectTypeId
    });
    this.set('_shouldLoadContentObject', false);
  }
});